<template>
  <v-btn
    icon
    color="primary"
    :loading="loading"
    :disabled="loading"
    @click="startGuide"
  >
    <v-icon>mdi-help-circle-outline</v-icon>
  </v-btn>
</template>

<script>
export default {
  props: {
    guideName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    startGuide() {
      this.loading = true;
      this.$store.dispatch('startGuideByName', { guideName: this.guideName })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
